export interface Volume {
  number: string;
  title: string;
  subtitle: string;
  body: { text: string; bold?: boolean }[];
  promise: string;
  featured?: boolean;
}

export const volumes: Volume[] = [
  {
    number: 'VOL. 01',
    title: 'Open Full: The Licensed Launch Path',
    subtitle:
      'Leave your job only after two families have signed and paid a deposit.',
    body: [
      { text: '7 chapters. Inside: ' },
      { text: 'The Bridge Plan', bold: true },
      { text: ', ' },
      { text: 'the two-anchor resignation rule', bold: true },
      { text: ', ' },
      { text: 'seasonal opening timing', bold: true },
      { text: ' and ' },
      { text: 'the Pre-Opening Waitlist', bold: true },
      {
        text: '. Licensing, setup and enrollment sequenced so you never carry an empty house and a lost paycheck in the same month.',
      },
    ],
    promise: '→ You open with income already committed, not with your fingers crossed.',
  },
  {
    number: 'VOL. 02',
    title: 'The Fill Engine: Never an Empty Seat',
    subtitle: 'The spot goes to whoever answers first.',
    body: [
      { text: '10 chapters. Inside: ' },
      { text: 'The Empty-Seat Calculator', bold: true },
      { text: ', ' },
      { text: 'the Two-Hour Inquiry Rule', bold: true },
      { text: ', ' },
      { text: 'the tour script', bold: true },
      { text: ', ' },
      { text: 'the follow-up sequence', bold: true },
      { text: ' and ' },
      { text: 'the listings and referral system', bold: true },
      {
        text: '. What an open seat actually costs you, and the exact response path that closes an inquiry before a competitor calls back.',
      },
    ],
    promise: '→ Inquiries turn into signed agreements instead of into voicemail.',
    featured: true,
  },
  {
    number: 'VOL. 03',
    title: 'The Keep Engine: Staff & Families That Stay',
    subtitle: "A house you refill every six months isn't full.",
    body: [
      { text: '6 chapters. Inside: ' },
      { text: 'the 30-Day Onboarding Plan', bold: true },
      { text: ', the ' },
      { text: 'three retention levers', bold: true },
      { text: ' — ' },
      { text: 'wages, behavior support and respect', bold: true },
      { text: ' — and the ' },
      { text: 'family retention systems', bold: true },
      {
        text: ' that keep enrolled families enrolled. Turnover is the most expensive line item you never see on a statement.',
      },
    ],
    promise: '→ You stop paying the hidden cost of replacing people who should have stayed.',
  },
  {
    number: 'VOL. 04',
    title: 'Paper Armor: The Inspection-Ready Binder',
    subtitle: 'The franchise binder, without the franchise fees.',
    body: [
      { text: '6 chapters plus the ' },
      { text: 'Forms Library (28 printable forms)', bold: true },
      { text: '. Inside: ' },
      { text: 'the 6-tab binder system', bold: true },
      { text: ', ' },
      { text: 'the Emergency folder', bold: true },
      { text: ' and ' },
      { text: 'the 60-second inspector test', bold: true },
      {
        text: '. Build it once, and every document a licensor asks for is behind the tab they ask for it in.',
      },
    ],
    promise: '→ An unannounced visit becomes a handoff instead of an emergency.',
  },
  {
    number: 'VOL. 05',
    title: 'Money That Stays',
    subtitle: "You don't have a low-revenue business. You have a leaky one.",
    body: [
      { text: '6 chapters. Inside: ' },
      { text: 'rate-setting by market band, cost floor and position', bold: true },
      { text: ', ' },
      { text: 'the Time-Space Percentage', bold: true },
      { text: ' and ' },
      { text: 'plugging the three leaks', bold: true },
      {
        text: '. What to charge, what you are legally leaving on the table, and where the money quietly disappears every month.',
      },
    ],
    promise: '→ The same enrollment produces more money, because less of it leaks out.',
  },
  {
    number: 'VOL. 06',
    title: 'Run Without Drowning',
    subtitle:
      'The house is full, the money collects, the binder is armored — now fix the days.',
    body: [
      { text: '6 chapters. Inside: ' },
      { text: 'The Daily Rhythm', bold: true },
      { text: ', ' },
      { text: 'the hard conversations', bold: true },
      { text: ', ' },
      { text: 'boundaries', bold: true },
      { text: ' and ' },
      { text: 'The Operating Week', bold: true },
      {
        text: '. The scripts and the schedule that stop the program from running on your last nerve.',
      },
    ],
    promise: '→ A full program you can still be in ten years from now.',
  },
];

export const startHere = {
  label: 'START HERE',
  title: 'Open Volume 2 first.',
  body:
    'An empty seat is the most expensive thing in your building. Run the Empty-Seat Calculator, put the Two-Hour Inquiry Rule and the tour script in place this week, and the system pays for itself before you reach Volume 3.',
};

export const insideEveryVolume = {
  title: 'Inside every volume',
  items: [
    'Printable checklists you can hang on the wall, not just read once.',
    'Fill-in-the-blank forms — your name, your rates, your state, done in an afternoon.',
    'Word-for-word scripts for the conversations you dread having.',
    'A one-page summary at the front of each volume for the days you have four minutes.',
    'Plain-English language you can hand directly to a parent without translating it.',
  ],
};

export const coverage = [
  'Launch & licensing',
  'Filling every seat',
  'Staff & family retention',
  'Inspection binder',
  'Rates & money leaks',
  'Daily operations',
];

export const productStats = [
  { value: '6', label: 'Volumes' },
  { value: '200+', label: 'Pages' },
  { value: '28', label: 'Printable forms' },
  { value: '60+', label: 'Word-for-word scripts' },
];
